import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

export function AdminShipping() {
  const [masterId, setMasterId] = useState<string>('');
  const [beyandDf, setBeyandDf] = useState<string>('');
  const [stpayDf, setStpayDf] = useState<string>('');
  const [stpayDf1, setStpayDf1] = useState<string>('');
  const dispatch = useDispatch();
  const history = useHistory();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  const param = {
    beyandDf,
    stpayDf,
    stpayDf1,
    masterId,
  };

  useEffect(() => {
    getDelivery();
    getUserInfo();
  }, []);

  // 본인 회원정보 조회 API 호출
  const getUserInfo = async () => {
    await server
      .getUserOwn()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setMasterId(payload.username);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 배송관리(배송비) 조회 API 호출
  const getDelivery = async () => {
    await server
      .getDelivery()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setBeyandDf(payload[0].beyandDf);
          setStpayDf(payload[0].stpayDf);
          setStpayDf1(payload[0].stpayDf1);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 배송관리(배송비) 변경 API 호출
  const onClickSave = async () => {
    if (beyandDf.length <= 0) {
      dispatch(toast.error({ message: '기준 배송료가 비어있습니다.' }));
    } else if (stpayDf.length <= 0) {
      dispatch(toast.error({ message: '기준 금액가 비어있습니다.' }));
    } else if (stpayDf1.length <= 0) {
      dispatch(toast.error({ message: '기준 금액 초과시 배송금액가 비어있습니다.' }));
    } else {
      await server
        .patchDelivery(param)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            dispatch(toast.info({ message: '배송정보가 저장되었습니다.' }));
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  return (
    <main className="shipping wrapper">
      <div className="title">
        <h1>배송정보 관리</h1>
        <div className="buttons">
          <button type="button" onClick={onClickSave}>
            저장
          </button>
        </div>
      </div>
      <div className="content">
        <ul className="inputs">
          <li className="price">
            <span className="required">기본 배송료</span>
            <input
              type="number"
              value={beyandDf}
              onChange={(event) => {
                setBeyandDf(event.target.value);
              }}
            />
          </li>
          <li className="price">
            <span className="required">기준 금액</span>
            <input
              type="number"
              value={stpayDf}
              onChange={(event) => {
                setStpayDf(event.target.value);
              }}
            />
          </li>
          <li className="price">
            <span className="required">기준 금액 초과시 배송금액</span>
            <input
              type="number"
              value={stpayDf1}
              onChange={(event) => {
                setStpayDf1(event.target.value);
              }}
            />
          </li>
        </ul>
      </div>
    </main>
  );
}
